import { timeStringToDate } from './time';
import {
  AlignmentStatuses,
  AlignmentIssuesTypes,
} from '../constants/alignment';
import { EMPTY_CELL_VALUE } from '../constants/tableRows';

export const dateOptions = {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
};

export const timeOptions = {
  hour: 'numeric',
  hour12: true,
  minute: 'numeric',
};

export const getMatchName = (item, intl) => {
  if (!item?.awayTeam || !item?.homeTeam) {
    return null;
  }

  return intl.formatMessage(
    {
      defaultMessage: '{homeTeam} vs {awayTeam}',
      id: 'd2af2',
    },
    { awayTeam: item.awayTeam, homeTeam: item.homeTeam },
  );
};

export const getMatchDateAndTime = (item, intl) => {
  const formattedDate = intl.formatDate(item?.matchDate, dateOptions);

  if (!item?.matchTime) {
    return formattedDate;
  }
  const time = timeStringToDate(item.matchTime);
  const formattedTime = intl.formatTime(time, timeOptions);

  return intl.formatMessage(
    {
      defaultMessage: '{date}, {time}',
      id: 'd90b2',
    },
    { date: formattedDate, time: formattedTime },
  );
};

export const getFormattedDateTime = (item, intl) => {
  if (!item) return null;

  const formattedDate = intl.formatDate(item, dateOptions);
  const formattedTime = intl.formatTime(item, timeOptions);

  return intl.formatMessage(
    {
      defaultMessage: '{date}, {time}',
      id: 'd90b2',
    },
    { date: formattedDate, time: formattedTime },
  );
};
export const getEventsLastUpdated = (item, intl) =>
  getFormattedDateTime(item.eventsUpdated, intl);
export const getAlignmentLastUpdated = (item, intl) =>
  getFormattedDateTime(item.alignmentLastUpdated, intl);

export const getButtonTitle = (intl) =>
  intl.formatMessage({
    defaultMessage: 'Review Offsets',
    id: '62cf2',
  });

export const getAlignmentStatusLabel = (alignmentStatus, intl) => {
  if (!alignmentStatus) {
    return intl.formatMessage({
      defaultMessage: 'Awaiting Review',
      id: '26fb3',
    });
  }

  return {
    [AlignmentStatuses.REQUIRES_NEW_HUDL_VIDEO]: intl.formatMessage({
      defaultMessage: 'Requires New Hudl Video',
      id: 'd5f60',
    }),
    [AlignmentStatuses.REQUIRES_RECOLLECTION]: intl.formatMessage({
      defaultMessage: 'Requires Recollection',
      id: '49e43',
    }),
    [AlignmentStatuses.AWAITING_REVIEW || null || undefined]:
      intl.formatMessage({
        defaultMessage: 'Awaiting Review',
        id: '26fb3',
      }),
  }[alignmentStatus];
};

export const getAlignmentIssueLabel = (alignmentIssue, intl) => {
  if (!alignmentIssue) return EMPTY_CELL_VALUE;

  return {
    [AlignmentIssuesTypes.LICENSED_VIDEO]: intl.formatMessage({
      defaultMessage: 'Licensed Video',
      id: '09408',
    }),
    [AlignmentIssuesTypes.UNLICENSED_VIDEO]: intl.formatMessage({
      defaultMessage: 'Unlicensed Video',
      id: '1a2a1',
    }),
  }[alignmentIssue];
};

export const getAlignmentOutcome = (playbackAndMinutesOk) => ({
  alignmentIssue: playbackAndMinutesOk
    ? AlignmentIssuesTypes.UNLICENSED_VIDEO
    : AlignmentIssuesTypes.LICENSED_VIDEO,
  alignmentStatus: playbackAndMinutesOk
    ? AlignmentStatuses.REQUIRES_RECOLLECTION
    : AlignmentStatuses.REQUIRES_NEW_HUDL_VIDEO,
});

export const generateDropdownOptionsFromEvents = (events, valueGetter) => {
  const uniqueValues = Array.from(
    new Set(events.map((item) => valueGetter(item))),
  ).filter(Boolean);

  return uniqueValues.map((value) => ({
    label: value,
    value,
  }));
};
